module.exports = __webpack_public_path__ + "img/DE00818.db23defc.png";